module.exports = __webpack_public_path__ + "static/media/IMG_8837.7f06ba6c.JPG";